<template>
    <div
        v-if="request"
        class="panel panel-default"
        data-testid="order-detail-return-request"
    >
        <div class="panel-heading clearfix">
            <h4 class="pull-left" style="margin: 0;">Richiesta di reso</h4>
            <span class="label label-warning pull-right">{{ request.statusLabel }}</span>
        </div>
        <div class="panel-body">
            <p v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</p>
            <p class="order-detail-v1-returns__gift-meta"><strong>{{ request.customerStatement }}</strong></p>
            <p class="text-muted">{{ request.freeReason }}</p>
            <ul class="list-unstyled">
                <li
                    v-for="line in request.lines"
                    :key="line.codiceRiga"
                    class="order-detail-v1-returns__line"
                >
                    <div><strong>{{ line.title || 'Riga reso' }}</strong></div>
                    <div class="text-muted">Quantità: {{ line.qty }}</div>
                    <div v-if="line.ean"><code>{{ line.ean }}</code></div>
                </li>
            </ul>
            <button type="button" class="btn btn-sm btn-default" :disabled="busy" @click="openDialog">
                Risolvi
            </button>
        </div>

        <div
            v-if="open"
            class="modal fade in"
            style="display: block;"
            role="dialog"
            data-testid="return-request-dialog"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="open = false"><span>&times;</span></button>
                        <h4 class="modal-title">Risolvi richiesta di reso</h4>
                    </div>
                    <div class="modal-body">
                        <p class="text-muted">{{ request.customerStatement }} — {{ request.freeReason }}</p>
                        <div class="radio" v-for="choice in request.acts" :key="choice.act">
                            <label>
                                <input v-model="act" type="radio" name="return-request-act" :value="choice.act">
                                {{ choice.label }}
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" :disabled="act === null || busy" @click="confirm">
                            Conferma
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="open" class="modal-backdrop fade in"></div>
    </div>
</template>

<script>
export default {
    name: 'OrderReturnRequestCard',
    props: {
        order: { type: Object, required: true },
    },
    data() {
        return { open: false, act: null, busy: false, errorMessage: null };
    },
    computed: {
        request() {
            return this.order.returnRequest || null;
        },
    },
    methods: {
        openDialog() {
            this.act = null;
            this.errorMessage = null;
            this.open = true;
        },
        async confirm() {
            this.busy = true;
            this.errorMessage = null;
            try {
                const url = this.order.endpoints && this.order.endpoints.returnRequest;
                if (!url) {
                    throw new Error('Endpoint non configurato.');
                }
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'X-CSRF-TOKEN': this.order.csrfToken || '',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify({
                        codice_righe: (this.request.lines || []).map((line) => line.codiceRiga),
                        act: Number(this.act),
                    }),
                });
                const payload = await response.json().catch(() => ({}));
                if (!response.ok || payload.success === false) {
                    throw new Error(payload.message || ('HTTP ' + response.status));
                }
                window.location.reload();
            } catch (err) {
                this.errorMessage = (err && err.message) || 'Operazione fallita.';
                this.open = false;
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>
